<template>
<b-form-input :id="'input' + index" v-model="inputModel" class="form-control" type="text" placeholder="" autocomplete="off"/>
<Typeahead :key="'input' + index" v-model="model" :target="'#input' + index" :async-function="getItems" item-key="label" :open-on-empty="true" :limit="999" >
    <template #item="{ items, activeIndex, select, highlight }">
      <li
        v-for="(item, index) in items"
        :key="item.id"
        :class="{ active: activeIndex === index }"
      >
        <a role="button" class="list-item" @click="select(item)">
          <div>{{item.label}}</div>
        </a>
      </li>
    </template>
</Typeahead>
</template>

<script>

import {
    Typeahead
} from 'uiv';
import { computed } from 'vue'
export default {
    components: {
        Typeahead,
    },
    emits:["locationInput"],
    props: ["modelValue", "index", "locationOptions", "lpWareHouseId" ],
    watch: {
        // When the query value changes, fetch new results from
        // the API - in practice this action should be debounced
        model(newValue) {
            this.$emit("locationInput", newValue);
        },
    },
    data() {
        return {
            model: "",
            inputModel: "",
            newvalue: "",
            options: [],
        };
    },
    mounted() {
        this.inputModel = this.modelValue.label;
        
    },
    methods: {
        getItems(newQuery, done) {  
            this.options = this.locationOptions.filter(item => String(item.warehouseId) === String(this.lpWareHouseId)).filter(item => item.label.includes(newQuery)).map((item,index) => ({
                ...item,
                id: index
            }));

            this.options.sort((a, b) =>
                a.label.toLowerCase().localeCompare(b.label.toLowerCase())
            )
            done(this.options)

        },
    },
};
</script>
<style lang="scss">
.typeahead-menu {
  position: absolute;
  z-index: 1050;
}
</style>